import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';

/** 00 h : 17 min : 34 sec */
const TOTAL_SECONDS = 17 * 60 + 34;
interface CountdownProps {
  tone?: 'light' | 'dark';
}
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const isDark = tone === 'dark';
  const blockClass = isDark ? 'bg-cream-100 text-navy-900' : 'bg-navy-800 text-cream-100';
  const labelClass = isDark ? 'text-cream-100/60' : 'text-navy-700/60';
  const headingClass = isDark ? 'text-gold-400' : 'text-navy-700';
  const units: Array<{
    value: number;
    label: string;
  }> = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="flex w-full flex-col items-center" data-id="element-95" data-mp="t124fk15vb0h">
      <p className={`flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.14em] ${headingClass}`} data-id="element-96" data-mp="17qzwib27okuy">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-97" data-mp="12rn0azpga1fp" />
        The special offer ends in:
      </p>

      <div className="mt-3 flex items-start justify-center gap-1.5 sm:gap-2" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-98" data-mp="f3dgg3bsrnr7">
        {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-99" data-mp="k1nceg5cisdv" data-mpi={index}>
            <div className="flex flex-col items-center" data-id="element-100" data-mp="jzu5czqtm65c">
              <div className={`flex h-16 w-[68px] items-center justify-center rounded-xl font-display text-3xl font-bold tabular-nums shadow-lift sm:h-[74px] sm:w-[82px] sm:text-4xl ${blockClass}`} data-id="element-101" data-mp="1zhw16oe4bj75">
                {String(unit.value).padStart(2, '0')}
              </div>
              <span className={`mt-1.5 text-[10px] font-bold uppercase tracking-[0.12em] ${labelClass}`} data-id="element-102" data-mp="x484eu7szzwx">
                {unit.label}
              </span>
            </div>
            {index < units.length - 1 ? <span className={`mt-4 font-display text-2xl font-bold ${isDark ? 'text-cream-100/40' : 'text-navy-800/30'}`} aria-hidden="true" data-id="element-103" data-mp="164msu2g2dv4n">
                :
              </span> : null}
          </React.Fragment>)}
      </div>
    </div>;
}